// extracted by mini-css-extract-plugin
export default {"link":"OD-z","disabled":"PD-z"};